import api from './axios'

/**
 * Solicita URL do dossiê PDF de convidados (com cache no backend/S3).
 * @returns {Promise<{ url: string, geradoEm: string, emCache: boolean, totalConvidados: number }>}
 */
export async function baixarDossieConvidados() {
  const resp = await api.get('/dossie-convidados')
  if (resp.status !== 200) {
    throw new Error(resp.data?.mensagem || 'Erro ao obter dossiê.')
  }
  return resp.data.dados
}

export async function abrirDossieConvidadosEmNovaAba() {
  const dados = await baixarDossieConvidados()
  if (dados?.url) {
    window.open(dados.url, '_blank', 'noopener,noreferrer')
  }
  return dados
}
